<style>

/*GENERAL */

@font-face {
  font-family: 'GothamBook';
  src: url('assets/fonts/Gotham-Book.woff2') format('woff2'),
        url('assets/fonts/Gotham-Book.woff') format('woff'),
        url('assets/fonts/Gotham-Book.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}



@font-face {
    font-family: 'GothamMedium';
    src:  url('assets/fonts/GothamMedium.ttf') format('truetype');
    font-weight: 500;
    font-display: swap;
}

@font-face {
    font-family: 'GothamBold';
    src:  url('assets/fonts/Gotham-Bold.otf') format('otf'),
          url('assets/fonts/Gotham-Bold.ttf') format('truetype');          
    font-weight: 800;
    font-style: bold;
    font-display: swap;
}



body{
  font-family: GothamMedium, sans-serif;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
}

div, h1, h2{
  display: inline-block;
  margin: 0;
}

h1, h2, h3{
  margin: 0;
  padding: 0;
}

ul {
    list-style-type: none;
    padding: 0;
  }

#app {
  color: #6f6f6f;
  width: 100%;
}

body{
line-height: 1.1;
}

a{
  display: inline-block
  }

  #phmFooterContent div{
  width: 100%;
}
#ot-sdk-btn.ot-sdk-show-settings{
  border: 1px solid #000 !important;
}
#phmFooterContent{
  display: block;
  text-align: center;
  margin-top: 50px;
  font-family: acumin-pro, sans-serif;
    font-size: 14px;
}
#phmFooterContent a{
  color: #363636;
}
#onetrust-consent-sdk div {
  display: block;
}
#phmFooterContent .footer .subpages li {
  padding-top: 5px;
}
@media (min-width: 680px) {
#phmFooterContent .footer .subpages li {
    display: inline-block;
    border-right: 1px solid #363636;
    margin-right: -4px;
    padding: 0 5px
}
#phmFooterContent .footer .subpages li:last-child {
    border-right: 0 none;
}
}

</style>

<template>
  <main>
    <div id="app">
    <router-view/>
    <Footer />
  </div>
  </main>
</template>

<script>
import Home from './components/Home'
import Footer from './components/Footer'
let h = document.querySelector('html');
h.setAttribute('lang', "en");
export default {
  
  components:{
    name: 'Home',
    'Home':Home
  },
  components:{
    name: 'Footer',
    'Footer':Footer
  },
}    
    

</script>


// WEBPACK FOOTER //
// src/App.vue